import { getRouteApi } from '@tanstack/react-router';
import { useCallback } from 'react';

import { definedSearchParams } from '@/lib/search-params';

import { GymsScreen } from './GymsScreen';
import type { GymsFilters } from './gyms-query';

const route = getRouteApi('/gyms');

export function GymsRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const onFiltersChange = useCallback(
    (next: GymsFilters) => {
      // `replace` so typing in the search box does not fill the history.
      void navigate({ replace: true, search: () => definedSearchParams(next) });
    },
    [navigate],
  );

  const onOpenGym = useCallback(
    (gymId: string) => {
      // A push: the back button returns to the filtered list.
      void navigate({ to: '/gyms/$gymId', params: { gymId } });
    },
    [navigate],
  );

  return <GymsScreen filters={search} onFiltersChange={onFiltersChange} onOpenGym={onOpenGym} />;
}
